import { sanitizeHtml } from './sanitizeHtml'

/**
 * Convierte el HTML de la sinopsis en texto plano.
 *
 * Se sanea primero y se quitan las etiquetas después: hacerlo al revés dejaría
 * pasar contenido de un `<script>` como si fuera texto.
 */
export function toPlainText(html: string): string {
  return sanitizeHtml(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
